import React from 'react'
import { isInstitutional } from '../../../../../global/authentication/authentication-manager.js'
import InstitutionalBlogArticleCard from './InstitutionalBlogArticleCard.jsx'
import AdvisorBlogArticleCard from './AdvisorBlogArticleCard.jsx'
import './BlogArticleCard.css'

function BlogArticleCard({
  item,
  taxonomies,
  children,
  hightlightOnHover = false,
}) {
  if (isInstitutional()) {
    return (
      <InstitutionalBlogArticleCard
        item={item}
        taxonomies={taxonomies}
        hightlightOnHover={hightlightOnHover}
      >
        {children}
      </InstitutionalBlogArticleCard>
    )
  }

  return (
    <AdvisorBlogArticleCard
      item={item}
      taxonomies={taxonomies}
      hightlightOnHover={hightlightOnHover}
    >
      {children}
    </AdvisorBlogArticleCard>
  )
}

export default BlogArticleCard
